export const speechMixin = {
    data() {
        return {
            selectedVoice: null,
            voicesLoaded: false,
        };
    },
    methods: {
        setupVoices() {
            const checkVoices = () => {
                const voices = window.speechSynthesis.getVoices();

                console.table(voices.map(v => ({
                    name: v.name,
                    lang: v.lang,
                    default: v.default
                })));


                if (voices.length === 0) {
                    setTimeout(checkVoices, 100); // Retry until voices are loaded
                } else {
                    // Prefer voices with "en-US"
                    const englishVoices = voices.filter(
                        (voice) => voice.lang === "en-US" && voice.name === "Samantha"
                    );

                    // Fallback to any English voice
                    const genericEnglishVoices = voices.filter((voice) =>
                        voice.lang.startsWith("en-US")
                    );

                    // Pick the best match
                    this.selectedVoice =
                        englishVoices[0] ||
                        genericEnglishVoices[0] ||
                        voices.find((v) => v.default) || 
                        voices[0];

                    this.voicesLoaded = true;
                }
            };

            // Sometimes voices are not immediately available
            if (typeof speechSynthesis !== "undefined" && speechSynthesis.onvoiceschanged !== undefined) {
                speechSynthesis.onvoiceschanged = checkVoices;
            }

            checkVoices();
        },
        speakOutLoud(item) {
            if (!this.selectedVoice || !item) return; // Don't speak if voice or item is not available
            const utteranceText = item.toString().toLowerCase();
            const utterance = new SpeechSynthesisUtterance(utteranceText);
            utterance.pitch = 1.2;
            utterance.rate = 0.7;
            utterance.voice = this.selectedVoice;

            window.speechSynthesis.speak(utterance);
        },
    },
};
